import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { Button, Container, DialogContent, DialogContentText, Grid } from "@mui/material";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import GenericTable from "common/components/GenericTable/GenericTable";

import GenericDialog from "common/components/GenericDialog/GenericDialog";
import { ApiService } from "common/services/ApiService";
import { useAuth } from "context/AuthContext";
import getColumns from "modules/activity/utils/getColumns";
import moment from "moment";
import { QUALIFICATION_LABEL, VISIBILITY, VISIBILITY_MAP } from "utils/constants";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <div>{children}</div>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const TAB_MAP = {
    0: "PEND",
    1: "CORR",
    2: "DELI",
    3: "REDE",
};

const Activities = () => {
    const [value, setValue] = useState(0);
    const { id, courseId } = useParams();
    const { auth } = useAuth();
    const navigate = useNavigate();
    const [rows, setRows] = useState();
    const [course, setCourse] = useState({});
    const [activity, setActivity] = useState({});
    const [showMore, setShowMore] = useState(false);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const getActivity = async () => {
        const result = await ApiService.getActivity(id);
        setActivity(result.data);
    };

    const getCourse = async (idCourse) => {
        const result = await ApiService.getCourse(idCourse);
        setCourse(result.data);
    };

    useEffect(() => {
        const getStudentActivities = async () => {
            const result = await ApiService.getStudentActivities({
                student: auth?.selectedRole?.name === "student" ? auth.userId : null,
                delivery_status: TAB_MAP[value],
                course: auth?.selectedRole?.name === "student" ? id : courseId,
                activity: ["teacher", "admin", "superadmin"].includes(auth?.selectedRole?.name)
                    ? id
                    : null,
                role_name: auth?.selectedRole?.name,
            });
            if (result.data.length === 0) {
                setRows([]);
                return;
            }
            const prueba = result.data[0];

            setRows(
                result.data.map((d) => ({
                    ...d.feedback,
                    ...d.course_activity.activity,
                    qualification: QUALIFICATION_LABEL[d?.feedback?.qualification] || null,
                    id: d.id,
                    userName: d.student.email,
                    firstName: d.student.first_name,
                    lastName: d.student.last_name,
                    hasNotifications: d.has_notifications,
                }))
            );
        };
        getStudentActivities();
    }, [value]);

    useEffect(() => {
        if (auth?.selectedRole?.name !== "student" && courseId) {
            getCourse(courseId);
        }
    }, [courseId]);

    useEffect(() => {
        if (auth?.selectedRole?.name !== "student") {
            getActivity();
        } else {
            getCourse(id);
        }
    }, [id]);

    const properties = [
        {
            title: "Fuente",
            description: activity?.static_data_source
                ? activity?.static_data_source?.name
                : "Reddit",
            show: true,
            showModal: true,
        },
        {
            title: "Título actividad",
            description: activity?.title,
            show: true,
            showModal: true,
        },
        {
            title: "Enunciado",
            description: activity?.statement,
            show: true,
            showModal: true,
        },
        {
            title: "Título enunciado",
            description: activity?.statement_title,
            show: true,
            showModal: true,
        },
        {
            title: "Descrición",
            description: activity?.description,
            show: true,
            showModal: true,
        },
        {
            title: "Objetivo",
            description: activity?.objetive,
            show: true,
            showModal: true,
        },
        {
            title: "Propietario actividad",
            description: activity?.owner?.email,
            show: true,
            showModal: true,
        },
        {
            title: "Fecha",
            description: moment(activity?.datetime_added).format("DD/MM/YYYY"),
            show: true,
            showModal: true,
        },
        {
            title: "Visibilidad",
            description: VISIBILITY_MAP[activity?.visiblity || VISIBILITY.public],
            show: true,
            showModal: true,
        },
    ];

    return (
        <Container>
            {/* <Box style={{ padding: "10px 0px 0px 0px" }}>
                <BackButton />
            </Box> */}
            {auth.selectedRole.name === "student" && <h1>{`Mis actividades - ${course?.name}`}</h1>}
            {auth.selectedRole.name !== "student" && (
                <div>
                    <h1>{course?.name}</h1>
                    <h3>Información de actividad </h3>
                    <Grid container>
                        {properties.slice(0, 3).map((property) =>
                            property.show ? (
                                <Grid item xs={12} md={4} key={property.title}>
                                    <u>
                                        <h4>{property.title}:</h4>
                                    </u>
                                    <h4
                                        style={{
                                            wordWrap: "break-word",
                                            overflow: "hidden",
                                            whiteSpace: "normal",
                                        }}
                                    >
                                        {property.description}
                                    </h4>
                                </Grid>
                            ) : (
                                <></>
                            )
                        )}
                        <GenericDialog
                            title="Información de la actividad"
                            open={showMore}
                            setOpen={setShowMore}
                            onClose={() => setShowMore(false)}
                            saveButton={false}
                            cancelButton={false}
                            mandatoryText={false}
                        >
                            <DialogContent>
                                <Grid container>
                                    {properties
                                        .filter((p) => p.showModal)
                                        .map((property) => (
                                            <Grid item xs={12} key={property.title}>
                                                <DialogContentText>
                                                    <strong>{property.title}:</strong>{" "}
                                                    {property.description}
                                                </DialogContentText>
                                            </Grid>
                                        ))}
                                </Grid>
                            </DialogContent>
                        </GenericDialog>

                        <Grid item xs={12}>
                            <Button
                                variant="text"
                                onClick={() => {
                                    setShowMore((prevState) => !prevState);
                                }}
                            >
                                Ver {!showMore ? "más" : "menos"}
                            </Button>
                        </Grid>
                    </Grid>
                </div>
            )}
            <Box sx={{ width: "100%", marginTop: "3%" }}>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                    <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                        <Tab label="Pendientes" {...a11yProps(0)} />
                        <Tab label="Corregidas" {...a11yProps(1)} />
                        <Tab label="Entregadas" {...a11yProps(2)} />
                        <Tab label="Pendientes (Reentrega)" {...a11yProps(3)} />
                        {/* <Tab label="Vencidas" {...a11yProps(4)} /> */}
                    </Tabs>
                </Box>
                <TabPanel value={value} index={0}>
                    {rows && (
                        <GenericTable
                            rows={rows}
                            columns={getColumns.getPendingColumns(
                                navigate,
                                auth?.selectedRole?.name
                            )}
                            columnVisibilityModel={{
                                title: auth?.selectedRole?.name === "student",
                                firstName: auth?.selectedRole?.name !== "student",
                                lastName: auth?.selectedRole?.name !== "student",
                                userName: auth?.selectedRole?.name !== "student",
                            }}
                        ></GenericTable>
                    )}
                </TabPanel>
                <TabPanel value={value} index={3}>
                    {rows && (
                        <GenericTable
                            rows={rows}
                            columns={getColumns.getPendingColumns(
                                navigate,
                                auth?.selectedRole?.name
                            )}
                            columnVisibilityModel={{
                                title: auth?.selectedRole?.name === "student",
                                firstName: auth?.selectedRole?.name !== "student",
                                lastName: auth?.selectedRole?.name !== "student",
                                userName: auth?.selectedRole?.name !== "student",
                            }}
                        ></GenericTable>
                    )}
                </TabPanel>
                <TabPanel value={value} index={1}>
                    {rows && (
                        <GenericTable
                            rows={rows}
                            columns={getColumns.getCorrectedColumns(
                                navigate,
                                auth?.selectedRole?.name
                            )}
                            columnVisibilityModel={{
                                title: auth?.selectedRole?.name === "student",
                                firstName: auth?.selectedRole?.name !== "student",
                                lastName: auth?.selectedRole?.name !== "student",
                                userName: auth?.selectedRole?.name !== "student",
                            }}
                        ></GenericTable>
                    )}
                </TabPanel>
                <TabPanel value={value} index={2}>
                    {rows && (
                        <GenericTable
                            rows={rows}
                            columns={getColumns.getDeliveredColumns(
                                navigate,
                                auth?.selectedRole?.name
                            )}
                            columnVisibilityModel={{
                                title: auth?.selectedRole?.name === "student",
                                firstName: auth?.selectedRole?.name !== "student",
                                lastName: auth?.selectedRole?.name !== "student",
                                userName: auth?.selectedRole?.name !== "student",
                            }}
                        ></GenericTable>
                    )}
                </TabPanel>
                <TabPanel value={value} index={4}>
                    {rows && (
                        <GenericTable
                            rows={rows}
                            columns={getColumns.getExpiredColumns()}
                        ></GenericTable>
                    )}
                </TabPanel>
                <TabPanel value={value} index={5}>
                    {rows && (
                        <GenericTable
                            rows={rows}
                            columns={getColumns.getDelayedColumns()}
                        ></GenericTable>
                    )}
                </TabPanel>
            </Box>
        </Container>
    );
};

export default Activities;
